import {
  AutoComplete,
  ISelectType,
  SwitchInput,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { listMainGenerics } from "../../../../../../../services/generic.service";
import { listTemplateGeneral } from "../../../../../../../services/templateGeneral.service";
import { TAutomationRuleEncMessageForm } from "./automationRuleEncMessageSchema";
import { useWatch } from "react-hook-form";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "chatBot.page.automations.automationRuleEncMessage.";

export const Then = memo(() => {
  const { t } = useTranslation();

  const [optionsListTemplateGeneral, setOptionsListTemplateGeneral] = useState<
    ISelectType[]
  >([]);

  const { sendRequest: listTemplateGeneralRequest } =
    useFetch(listTemplateGeneral);

  const { control, setValue } = useFormContext<TAutomationRuleEncMessageForm>();

  const { automation } = useAutomationRules();

  const automationCode = useMemo(
    () => (automation && automation.code ? automation.code : null),
    [automation]
  );

  const exceptionWatch = useWatch({
    control,
    name: "exception",
  });

  const paramsSendTypeEmrResult = useMemo(
    () => ({ Identifier: "SendTypeEmrResult" }),
    []
  );

  const paramsSendTypePasswordEmrResult = useMemo(
    () => ({ Identifier: "SendTypePasswordEmrResult" }),
    []
  );

  const templateGeneralTypeCode = useMemo(() => {
    switch (automationCode) {
      case "28":
        return "1";
      case "29":
        return "2";
      default:
        return null;
    }
  }, [automationCode]);

  const fetchListTemplateGeneral = useCallback(async () => {
    const { data, success } = await listTemplateGeneralRequest({
      TemplateGeneralTypeCode: templateGeneralTypeCode,
    });
    if (data && success) {
      setOptionsListTemplateGeneral(
        data.map((d) => ({
          id: d.id,
          name: d.name,
        }))
      );
    }
  }, [listTemplateGeneralRequest]);

  useEffect(() => {
    fetchListTemplateGeneral();
  }, [fetchListTemplateGeneral]);

  useEffect(() => {
    if (exceptionWatch) {
      setValue("send", false);
      setValue("sendTypeEmrResult", null);
      setValue("templateGeneral", null);
      setValue("sendTypePasswordEmrResult", null);
    }
  }, [exceptionWatch]);

  return (
    <Grid
      container
      spacing={2}
      sx={(t) => ({
        mt: 5,
        pr: 3,
        pl: 1,
        py: 3,
        border: `1px solid ${t.palette.divider}`,
        borderRadius: 2,
      })}
    >
      <Grid item sm={12}>
        <Typography fontWeight="bold">{t(translationPath + "then")}</Typography>
      </Grid>

      <Grid item xs={12}>
        <SwitchInput
          name="send"
          disabled={exceptionWatch}
          label={t(translationPath + "send")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AutoComplete
          params={paramsSendTypeEmrResult}
          name="sendTypeEmrResult"
          size="small"
          label={t(translationPath + "sendTypeEmrResult")}
          getOptionLabel={({ name }) => name}
          request={listMainGenerics}
          disable={exceptionWatch}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AutoComplete
          name="templateGeneral"
          size="small"
          label={t(translationPath + "templateGeneral")}
          options={optionsListTemplateGeneral}
          getOptionLabel={({ name }) => name}
          disable={exceptionWatch}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <AutoComplete
          params={paramsSendTypePasswordEmrResult}
          name="sendTypePasswordEmrResult"
          size="small"
          label={t(translationPath + "sendTypePasswordEmrResult")}
          getOptionLabel={({ name }) => name}
          request={listMainGenerics}
          disable={exceptionWatch}
        />
      </Grid>
    </Grid>
  );
});
